// UpdateAvailableBanner — surfaces the registerSW 'pwa:update-available' event
// as a small toast at the top of the viewport. Single button: "Reîncarcă".
//
// Why a banner not auto-reload? On mobile, the user might be in the middle of
// filling a booking or reading a chat; an auto-reload would dump their
// progress. They get to choose when to refresh.

import { useEffect, useState } from 'react'
import { RefreshCw } from 'lucide-react'

export default function UpdateAvailableBanner() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const handler = () => setShow(true)
    window.addEventListener('pwa:update-available', handler)
    return () => window.removeEventListener('pwa:update-available', handler)
  }, [])

  if (!show) return null

  return (
    <div
      role="alert"
      aria-live="polite"
      className="fixed top-2 left-2 right-2 md:top-4 md:left-1/2 md:-translate-x-1/2 md:max-w-md md:right-auto z-[55] safe-top bg-blue-600 text-white rounded-2xl shadow-lg flex items-center gap-2 px-4 py-3 animate-[fadeUp_0.25s_ease-out]"
    >
      <RefreshCw className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <span className="text-sm font-medium flex-1 leading-tight">Versiune nouă disponibilă</span>
      <button
        onClick={() => window.location.reload()}
        className="text-sm font-semibold bg-white/15 hover:bg-white/25 active:bg-white/30 transition px-3 py-1.5 rounded-lg"
      >
        Reîncarcă
      </button>
    </div>
  )
}
